import { TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL } from './texts';
import { DEFAULT_LANGUAGE } from '../common-language';
import { COLORS } from '../colors';

export const CHART_BAR_LINE_TAREAS_AYUNTAMIENTO = {
  color: [COLORS.naranjaPalido, COLORS.tealPalido, COLORS.cranberry],
  grid: {
    left: '0',
    right: '1%',
    bottom: '30',
    top: '70',
    containLabel: true,
  },
  title: {
    text: TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get('tareas'),
    margin: 0,
    padding: 0,
    top: '5',
    left: '50%',
    textAlign: 'center',
    itemGap: 5,
    textStyle: {
      fontSize: 13,
      fontFamily: 'Montserrat',
      fontWeight: 500,
      color: '#666',
    },
    subtext: '',
    subtextStyle: {
      fontFamily: 'Montserrat',
      fontSize: 13,
      lineHeight: 13,
      fontWeight: 400,
      color: '#666',
    },
  },
  legend: {
    show: true,
    orient: 'horizontal',
    bottom: '0',
    left: 'center',
    padding: [0, 5],
    itemWidth: 6,
    itemGap: 3,
    icon: 'circle',
    textStyle: {
      fontSize: '10',
      fontFamily: 'Montserrat',
      fontWeight: '400',
      color: '#666',
    },
    data: [
      TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
        'tareas_realizadas',
      ),
      TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
        'tareas_pendientes',
      ),
      TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
        'carga_administrativa',
      ),
    ],
  },
  toolbox: {
    show: true,
    right: '0',
    top: '5',
    feature: {
      restore: {
        title:
          TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get('reset'),
      },
      saveAsImage: {
        title:
          TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
            'download',
          ),
      },
    },
    emphasis: {
      iconStyle: {
        borderColor: '#ffcd00',
        shadowColor: '#333',
      },
    },
  },
  tooltip: {
    trigger: 'axis',
    confine: true,
    axisPointer: {
      type: 'shadow',
    },
    textStyle: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: 500,
    },
    formatter: '',
    valueFormatter: undefined,
  },
  xAxis: [
    {
      type: 'category',
      data: [],
      axisTick: { show: false },
      boundaryGap: ['20%', '20%'],
      gridIndex: 0,
      offset: 0,
      axisLine: {
        lineStyle: {
          color: '#ccc',
        },
      },
    },
  ],
  graphic: [
    {
      id: 'textTareas',
      type: 'text',
      left: 0,
      top: 44,
      style: {
        text: TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
          'tasks',
        ),
        fontSize: 12,
        fontFamily: 'Montserrat',
        fontWeight: 600,
        fill: '#666',
      },
    },
    {
      id: 'textDias',
      type: 'text',
      right: 0,
      top: 43,
      style: {
        text: TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
          'dias',
        ),
        fontSize: 12,
        fontFamily: 'Montserrat',
        fontWeight: 600,
        fill: '#666',
      },
    },
  ],
  yAxis: [
    {
      type: 'value',
      alignTicks: true,
      position: 'right',
      axisLabel: {
        margin: 5,
        textStyle: {
          fontSize: 8,
          fontFamily: 'Montserrat',
          fontWeight: 400,
        },
        formatter: (value) => `${value}`,
      },
    },
    {
      type: 'value',
      alignTicks: true,
      position: 'left',
      min: 0,
      axisLabel: {
        margin: 5,
        textStyle: {
          fontSize: 8,
          fontFamily: 'Montserrat',
          fontWeight: 400,
        },
        formatter: (value) => `${value}`,
      },
    },
  ],
  series: [
    {
      name: '',
      yAxisIndex: 1,
      type: 'bar',
      barMinWidth: 3,
      barMaxWidth: 8,
      data: [],
      label: { show: false },
    },
    {
      name: '',
      yAxisIndex: 1,
      type: 'bar',
      barMinWidth: 3,
      barMaxWidth: 8,
      data: [],
      label: { show: false },
    },
    {
      name: '',
      type: 'line',
      data: [],
      smooth: 'true',
      symbol: 'circle',
      symbolSize: '5',
      label: { show: false },
    },
  ],
  dataZoom: [
    {
      type: 'slider',
      show: true,
      xAxisIndex: 0,
      bottom: 0,
      left: 0,
      right: 5,
      borderColor: '#eee',
      fillerColor: 'rgba(0,0,0,.05)',
      textStyle: {
        fontSize: 10,
        fontFamily: 'Montserrat',
        color: '#333',
        textBorderColor: '#fff',
        textBorderWidth: 3,
        fontWeight: '600',
      },
      selectedDataBackground: {
        lineStyle: {
          color: '#333',
        },
        areaStyle: {
          color: '#72A0C1',
        },
      },
      dataBackground: {
        backgroundColor: 'rgba(0,0,0,1)',
        lineStyle: {
          color: '#333',
        },
        areaStyle: {
          color: 'rgba(0,0,0,0.5)',
        },
      },
      handleStyle: {
        color: 'rgba(0,0,0,0.2)',
      },
      moveHandleStyle: {
        color: 'rgba(0,0,0,0.3)',
      },
      emphasis: {
        handleStyle: {
          color: '#72A0C1',
        },
        moveHandleStyle: {
          color: '#5D8AA8',
        },
      },
    },
  ],
  media: [],
};
